(function () {
    'use strict';

    angular
        .module('app.userAndBillingOverview')
        .factory('userAndBillingOverviewService', ['$q', '$http', '$rootScope',
            function ($q, $http, $rootScope) {
                var service = {};

                function checkResponse(data) {
                  return data;
                }

                function getMessage(data) {
                  if (data) {
                    return data.message;
                  }
                  return false;
                }

                function handleRequest(url, method, params, loader, isGetTotalCount) {
                    var deferred = $q.defer();

                    var req = {
                        url: url,
                        method: method,
                        data: JSON.stringify(params),
                        loader: loader,
                        isGetTotalCount: isGetTotalCount
                    } 

                    $http(req)
                        .success(function (data) {
                        var dataRes = angular.fromJson(data);

                        if (checkResponse(dataRes)) {
                            deferred.resolve(dataRes);
                        } else {
                            deferred.reject(getMessage(dataRes));
                        }
                    })
                        .error(function (error) {
                            deferred.reject(error);
                        });

                    return deferred.promise;
                }

                function getAccounts(params, loader) {
                    var url_getAccounts = $rootScope.apiUrl + 'admin/searchCompanies';
                    return handleRequest(url_getAccounts, 'POST', params, loader);
                }

                function getNumberOfAccounts(params) {
                    var url_getNumberOfAccounts = $rootScope.apiUrl + 'admin/getNumberOfCompanies';
                    return handleRequest(url_getNumberOfAccounts, 'POST', params, false, true);
                }

                function getAccountTypes(loader) {
                    var url_getAccountTypes = $rootScope.apiUrl + 'admin/getAllCompanyType';
                    return handleRequest(url_getAccountTypes, 'GET', null, loader);
                }

                function getAddressByType(account_id, address_type, loader) {
                    var url_getAddressByType = $rootScope.apiUrl + 'admin/getAddressByType/' + account_id + '/' + address_type;
                    return handleRequest(url_getAddressByType, 'GET', null, loader);
                }

                service.getAccounts = getAccounts;
                service.getNumberOfAccounts = getNumberOfAccounts;
                service.getAccountTypes = getAccountTypes;
                service.getAddressByType = getAddressByType;

                return service;
            }
        ]);
})();
